import React from 'react';
import className from 'classnames';
import {get} from 'lodash';

import {
  availableBanTimes,
} from '../lib/helpers';

import {
  useModal,
} from '../hooks';

import {
  canBan,
} from '../lib/policies';

import UserNoteEditModal from './UserNoteEditModal';

const PenaltyTools = ({
  isBanned,
  userId,
  banUntil,
  bannedTimeLeft,
  type,
  postId,
  uuid,
  tableView = false,
}) => {
  const [
    modal,
    modalSet,
  ] = useModal()  // UserNoteEditModal has its own way of keyboard bindings.

  function toggleKenta() {
    modalSet(isBanned ? 'specific' : get(availableBanTimes, '[0].key'))
  }

  function toggleBan() {
    modalSet('permanent')
  }

  return (
    <React.Fragment>
      {tableView ?
        <React.Fragment>
          <a
            title='Kenta'
            className={className('Table__controls__a', {
              'Table__controls__a--lock': true,
              'Table__controls__a--lock--active': isBanned,
            })}
            onClick={toggleKenta}
          />

          {canBan('User') &&
            <a
              title='Ban'
              className='Table__controls__a Table__controls__a--no-entry'
              onClick={toggleBan}
            />
          }
        </React.Fragment>
      :
        <div className='Table__ban-temporary'>
          <a
            className='Badge Badge--icon-lock Badge--icon-alone Badge--orange'
            onClick={toggleKenta}
          />

          {canBan('User') &&
            <a
              className='Badge Badge--icon-no-entry Badge--icon-alone Badge--red'
              onClick={toggleBan}
            />
          }

        </div>
      }

      <UserNoteEditModal
        isActive={modal}
        isBanning
        isBanningEdit={isBanned}
        onToggleModal={() => {
          modalSet(false)
        }}
        userId={userId}
        bannedTimeLeft={bannedTimeLeft}
        banTime={modal}
        banUntil={banUntil}
        postId={postId}
        type={type}
        uuid={uuid}
      />
    </React.Fragment>
  );
}

export default PenaltyTools
